import React from "react";
import logoWhite from '../../assets/logo-blanc.png';

import CONFIG from '../../config';

import axios from "axios";
import { Link } from "react-router-dom";
import LogoutIcon from '@mui/icons-material/Logout';


function NavbarTop() {
  const [user, setUser] = React.useState(null);

  React.useEffect(() => {
    axios.get(CONFIG.API_URL + '/api/me', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            setUser(response.data);
            break;

          default:
            break;
        }
      })
      .catch((e) => {

      });
  }, []);


  return (
    <>
      <header className="sticky top-0 z-50">
        <div className="flex items-center justify-between bg-ame-gray text-white w-full">
          <div className="text-left mx-6 w-24 h-24">
            <a href="https://mouv-immo.com/">
              <img src={logoWhite} alt="Logo" />
            </a>
          </div>

          <div className="text-center mx-6 text-xl">
            <b>Téléphone :</b> <a href="tel:+33 4 81 91 24 58">
              04 81 91 24 58
            </a>
            <br></br>
            <b>Email :</b> <a href="mailto:agence@mouv-immo.com">
              agence@mouv-immo.com
            </a>
          </div>

          {user !== null &&
            <div className="flex items-end text-right mx-6">
              <div className="mr-2">
                {user.prenom} {user.nom}
              </div>
              <div className="">
                <Link to="/deconnexion">
                  <LogoutIcon sx={{ color: '#FFFFFF' }} />
                </Link>
              </div>
            </div>
          }
        </div>
      </header>
    </>
  );
}

export default NavbarTop;